import { vxm } from '@/state/index'

// main server url, specify command end points below
const { apiUrl } = process.env

/**
 * Time out (in ms) for requests to the server
 * (be generous, server might need 'warm up')
 * */
export const API_TIMEOUT = 20000 // ms
/** Url to the command endpoint  */
export const commandUrl = `${apiUrl}/command`
/** Url to the ping endpoint */
export const pingUrl = `${apiUrl}/ping`
/**
 * lambda function that returns the current users' auth
 * token (jwt). Used for authentication on the server.
 */
export const getAuthTokenFn = async () => vxm.authUser.idToken
